import React from "react";
import { Alert, Box } from "@mui/material";
import { SxStyleSheet } from "providers/UIProvider";

interface ErrorAlertProps {
  message: string;
}

export const ErrorAlert = ({ message }: ErrorAlertProps) => {
  return (
    <Box sx={styles.root}>
      <Alert severity="error">{message}</Alert>
    </Box>
  );
};

const styles: SxStyleSheet = {
  root: {
    padding: 2,
    width: "100%",
  },
};
